import type { PetBaseVariant } from '../compositor/assetPaths';
import { PetFace } from '../pet3d/PetFace';

/**
 * A hatchling cropped to the pet. Every hatchling is drawn on the shared stage lock (DESIGN.md §31),
 * which puts the body at x 26–74 %, y 41–96 % of a 1024 square (measured with sharp's trim across
 * the species) — shown whole, a portrait is two thirds empty paper. `.pet-crop` keeps the square
 * box and scales the image so that band fills it. Sizing is the caller's: give the box a width.
 */
export function HatchlingPortrait({ code, variant = 'base', className }: { code: string; variant?: PetBaseVariant; className?: string }) {
  return (
    <span className={className ? `pet-crop ${className}` : 'pet-crop'} aria-hidden="true">
      <PetFace species={code} stage="hatchling" variant={variant} alt="" width={128} height={128} />
    </span>
  );
}
